import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CourseType, LearnModule, LearnModuleType } from '@cna/projects/ak-jura/shared/interfaces';
import type { UUID } from '@cna/shared/generic-types';

const moduleTypeOrder = [LearnModuleType.Module, LearnModuleType.Repetitorium];

@Component({
    selector: 'cna-learning-dashboard-tile-grid',
    templateUrl: './learning-dashboard-tile-grid.component.html',
    styleUrls: ['./learning-dashboard-tile-grid.component.scss'],
})
export class LearningDashboardTileGridComponent {
    @Input()
    public set modules(modules: LearnModule[]) {
        this.sortedModules = [...modules].sort((m1, m2) => {
            if(m1.type !== m2.type) {
               return (moduleTypeOrder.indexOf(m1.type) ?? 0) - (moduleTypeOrder.indexOf(m2.type) ?? 0);
            }
            return (m1.sequentialNumber ?? 0) - (m2.sequentialNumber ?? 0);
        });
    }
    @Input()
    public courseType: CourseType;
    @Input()
    public mayAccessLearning: { allowed: boolean; reason?: string } | undefined;

    @Output()
    public selectModule = new EventEmitter<{ moduleId: UUID }>();
   @Output()
    public printModule = new EventEmitter<{ moduleId: UUID }>();

    CourseType = CourseType;

    sortedModules: LearnModule[];

    async navigateToModule(event: { moduleId: UUID }): Promise<void> {
        this.selectModule.emit(event);
    }

    async onPrintModule(event: { moduleId: UUID }): Promise<void> {
        this.printModule.emit(event);
    }
}
